import styled from '@emotion/styled'
import { ForwardedRef, forwardRef, memo, RefObject } from 'react'
import i18n from '../../../utilities/i18n'
import { safeObj } from '../../../utilities/safe'
import { smallHeightDialogCheck } from '../../styles/breakpoints'

const NoResultsContainer = styled('div')({
    width: '100%',
    height: '100%',
    paddingTop: '4rem',
    textAlign: 'center',
    alignItems: 'center',
    // textShadow: `1px 1px 1px ${palette.contrastText}`,
    [smallHeightDialogCheck]: {
        height: 240,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 0,
    },
})

const SearchQuery = styled('span')({
    fontWeight: 600,
})

interface INoResults {
    styleOverrides?: any
    ref?: any
    searchQuery?: string
}

const NoResults = (props: INoResults, ref: ForwardedRef<string>) => {
    const { current: refQuery = null } = safeObj(ref as RefObject<string>)
    const { searchQuery: propQuery = null, styleOverrides } = props

    const searchQuery = refQuery || propQuery

    return searchQuery && searchQuery !== '' ? (
        <NoResultsContainer
            css={styleOverrides}
            data-testid="Container__EmptySearchResults"
        >
            <p>
                {i18n.t('search.sorryNothingCameUpFor')} &quot;
                <SearchQuery>{searchQuery}</SearchQuery>
                &quot;.
            </p>
        </NoResultsContainer>
    ) : (
        <NoResultsContainer
            css={styleOverrides}
            data-testid="Container__EmptySearchResults"
        >
            <p>{i18n.t('search.sorryNothingCameUp')}</p>
        </NoResultsContainer>
    )
}

export default memo(forwardRef(NoResults))
